import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
import { BladeHeaderBody, BladeHeaderTitle } from "../../../../components/BladeHeader";
import { CardImage } from "../../../../components/Card";
export const arcaneSkin = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  ${BladeHeaderTitle} > h2 {
    ${chroma.typography.display3};
  }

  ${BladeHeaderBody} {
    ${chroma.mediaQueries.desktopUp} {
      margin: 0;
    }

    align-items: center;
  }

  ${CardImage} {
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(360deg, rgba(0 0 0 / 70%) 0%, rgba(0 0 0 / 0%) 93%);
    }
  }
`;
//# sourceMappingURL=index.js.map